import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { isNative } from './api';
import './index.css';
import App from './App';
import CallPage from './CallPage';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/call/:callId" element={<CallPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// Register service worker for PWA/offline in production web builds only.
// Native apps bundle their assets, and a service worker would serve stale builds after an app update.
if (isNative) {
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      // Activate updated SW and refresh to get latest assets.
      registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  });
}
